import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-208" data-mp="21ydbohrq2ixm">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-slate-300/30 border-l-4 border-l-slate-300 bg-blue-950 p-4 pr-10 text-white shadow-2xl shadow-black/40" aria-live="polite" data-id="element-209" data-mp="1wxxvlig22xby">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-slate-400 transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-300" aria-label="Dismiss notice" data-id="element-210" data-mp="1sdth7h1vhgu1">
            <XIcon className="h-4 w-4" data-id="element-211" data-mp="19owqto9lj8h3" />
          </button>
          <div className="flex gap-3" data-id="element-212" data-mp="19nbvvxjddnip">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-slate-300" aria-hidden="true" data-id="element-213" data-mp="1egeoo3gbosxu" />
            <div data-id="element-214" data-mp="zs0ch1x0ns4m">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-slate-300" data-id="element-215" data-mp="zsju0hir8ei4">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-slate-300" data-id="element-216" data-mp="14qle95rx2jv6">
                Once your purchase is complete you receive the
                <br data-id="element-217" data-mp="vpngh582n8l1" />
                <span className="font-bold text-white" data-id="element-218" data-mp="vpwz27qsedgp">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-slate-400" data-id="element-219" data-mp="2xfciagap7ck0">Instant digital access by email</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}